/**
 * @generated SignedSource<<6c15aaca84140f2fc0a4e65c23758769>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OnboardingChecklistItemKind = "add_custom_profile_fields" | "create_automation" | "create_community" | "create_course" | "create_group" | "create_test_member" | "customize_branding_and_appearance" | "customize_member_onboarding" | "download_mobile_app" | "introduction_to_community_home" | "introduction_to_learning_products" | "introduction_to_member_management" | "invite_admins" | "invite_members" | "set_up_community_public_page" | "write_description" | "write_welcome_post" | "%future added value";
export type OnboardingChecklistSectionKind = "build_learning_products" | "customize_community" | "launch_invite_members" | "manage_segment_members" | "set_up_community_home" | "%future added value";
export type OnboardingChecklistContextQuery$variables = {
  id: string;
};
export type OnboardingChecklistContextQuery$data = {
  readonly node: {
    readonly onboardingChecklistSections?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly content: {
            readonly kind: OnboardingChecklistSectionKind;
          };
          readonly id: string;
          readonly items: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly completedAt: string | null;
                readonly content: {
                  readonly kind: OnboardingChecklistItemKind;
                  readonly name: string;
                };
                readonly id: string;
                readonly organizationOnboardingChecklistSectionId: string;
              };
            }>;
          };
          readonly " $fragmentSpreads": FragmentRefs<"AdminOnboardingChecklistSectionFragment">;
        };
      }>;
      readonly totalCount: number;
    };
    readonly viewerMembership?: {
      readonly hideOnboardingChecklist: boolean;
    } | null;
  } | null;
};
export type OnboardingChecklistContextQuery = {
  response: OnboardingChecklistContextQuery$data;
  variables: OnboardingChecklistContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hideOnboardingChecklist",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedAt",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationOnboardingChecklistSectionId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OnboardingChecklistContextQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationMembership",
                "kind": "LinkedField",
                "name": "viewerMembership",
                "plural": false,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationOnboardingChecklistSectionNodeConnection",
                "kind": "LinkedField",
                "name": "onboardingChecklistSections",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrganizationOnboardingChecklistSectionNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrganizationOnboardingChecklistSection",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OnboardingChecklistSection",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AdminOnboardingChecklistSectionFragment"
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationOnboardingChecklistItemNodeConnection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrganizationOnboardingChecklistItemNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrganizationOnboardingChecklistItem",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OnboardingChecklistItem",
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v7/*: any*/),
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OnboardingChecklistContextQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationMembership",
                "kind": "LinkedField",
                "name": "viewerMembership",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "OrganizationOnboardingChecklistSectionNodeConnection",
                "kind": "LinkedField",
                "name": "onboardingChecklistSections",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "OrganizationOnboardingChecklistSectionNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "OrganizationOnboardingChecklistSection",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OnboardingChecklistSection",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v4/*: any*/),
                              (v6/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrganizationOnboardingChecklistItemNodeConnection",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrganizationOnboardingChecklistItemNodeEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OrganizationOnboardingChecklistItem",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v4/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OnboardingChecklistItem",
                                        "kind": "LinkedField",
                                        "name": "content",
                                        "plural": false,
                                        "selections": [
                                          (v5/*: any*/),
                                          (v6/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "description",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "helpArticle",
                                            "storageKey": null
                                          },
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Organization",
                                        "kind": "LinkedField",
                                        "name": "organization",
                                        "plural": false,
                                        "selections": [
                                          (v4/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v8/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "078882d03be3c9a025a51eecfc6e150c",
    "id": null,
    "metadata": {},
    "name": "OnboardingChecklistContextQuery",
    "operationKind": "query",
    "text": "query OnboardingChecklistContextQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on Organization {\n      viewerMembership {\n        hideOnboardingChecklist\n        id\n      }\n      onboardingChecklistSections {\n        totalCount\n        edges {\n          node {\n            id\n            content {\n              kind\n              id\n            }\n            ...AdminOnboardingChecklistSectionFragment\n            items {\n              edges {\n                node {\n                  id\n                  content {\n                    kind\n                    name\n                    id\n                  }\n                  completedAt\n                  organizationOnboardingChecklistSectionId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AdminOnboardingChecklistItemTemplateFragment on OrganizationOnboardingChecklistItem {\n  id\n  completedAt\n  content {\n    kind\n    name\n    description\n    helpArticle\n    id\n  }\n  ...OnboardingChecklistItemCTAButtonFragment\n  ...OnboardingChecklistItemImageFragment\n}\n\nfragment AdminOnboardingChecklistSectionFragment on OrganizationOnboardingChecklistSection {\n  id\n  content {\n    kind\n    name\n    id\n  }\n  items {\n    totalCount\n    edges {\n      node {\n        id\n        ...AdminOnboardingChecklistItemTemplateFragment\n      }\n    }\n  }\n}\n\nfragment OnboardingChecklistItemCTAButtonFragment on OrganizationOnboardingChecklistItem {\n  completedAt\n  content {\n    kind\n    id\n  }\n  organization {\n    id\n  }\n}\n\nfragment OnboardingChecklistItemImageFragment on OrganizationOnboardingChecklistItem {\n  content {\n    kind\n    name\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "bdffba2d335f3477acd11f2fc944a0ac";

export default node;
